import React from "react";
import PropTypes from "prop-types";
import Prism from "prismjs";
import "prismjs/components/prism-clike";
import "prismjs/components/prism-javascript";
import "prismjs/components/prism-python";
import "prismjs/components/prism-java";
import "prismjs/components/prism-sql";
import "prismjs/components/prism-go";
import "prismjs/themes/prism-tomorrow.css";

/**
 * Renders `text` as a syntax-highlighted code block when it contains newlines,
 * otherwise renders as plain text.
 */
export default function CodeBlock({ text, lang = "javascript", className = "" }) {
    const isCode = text?.includes("\n");

    if (!isCode) {
        return <span className={className}>{text}</span>;
    }

    const grammar = Prism.languages[lang] ?? Prism.languages.javascript;
    const highlighted = Prism.highlight(text, grammar, lang);

    return (
        <div className="rounded-xl overflow-hidden border border-gray-700/60 mt-1">
            {/* Header bar */}
            <div className="flex items-center justify-between bg-[#0d0f14] px-4 py-1.5 border-b border-gray-700/60">
                <span className="text-[10px] text-gray-500 uppercase tracking-widest font-mono">{lang}</span>
                <div className="flex gap-1.5">
                    <span className="w-2.5 h-2.5 rounded-full bg-red-500/60" />
                    <span className="w-2.5 h-2.5 rounded-full bg-yellow-500/60" />
                    <span className="w-2.5 h-2.5 rounded-full bg-green-500/60" />
                </div>
            </div>
            {/* Code */}
            <pre
                className="text-sm leading-relaxed overflow-x-auto p-4 m-0 bg-[#0d0f14]"
                style={{ fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace" }}
            >
                <code
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{ __html: highlighted }}
                />
            </pre>
        </div>
    );
}

CodeBlock.propTypes = {
    text: PropTypes.string.isRequired,
    lang: PropTypes.string,
    className: PropTypes.string,
};

